export default __webpack_public_path__ + "static/ola-f1a1aa04c18ee8b62197aeb3d5ed6e08.png";